import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import { Box, Paper, Tabs, Text, Title } from "@mantine/core";
import BackNavigationButton from "../../../../common/components/BackNavigationButton/BackNavigationButton";
import { fetcher } from "../../../../services/fetcher";
import { explorePlansApi } from "../../services/explorePlansApi";

const TAB_VALUES = ["itinerary", "comparisons", "notes"];

const tabFromPathname = (pathname) => {
  const parts = pathname.split("/").filter(Boolean);
  const last = parts[parts.length - 1] || "";
  return TAB_VALUES.includes(last) ? last : "itinerary";
};

const ExploreProfileManageLayout = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const tab = tabFromPathname(location.pathname);

  const { data } = useSWR(explorePlansApi.detail(id), fetcher, {
    revalidateOnFocus: false,
  });

  const profileTitle =
    data?.cover_title || data?.subtitle || `Profile #${id}`;

  const basePath = `/cover-api/explore-plans/open/${id}`;

  return (
    <Box
      p={{ base: "md", sm: "lg" }}
      bg="#f1f5f9"
      mih="100%"
      style={{ borderRadius: 0 }}
    >
      <BackNavigationButton mb="md" fallbackTo="/cover-api/explore-plans" />
      <Paper
        radius="md"
        p={{ base: "md", sm: "lg" }}
        withBorder
        shadow="sm"
        bg="#fff"
        maw={1280}
        mx="auto"
      >
        <Title order={3} c="#092c4c" fw={700} lineClamp={2}>
          {profileTitle}
        </Title>
        <Text size="xs" c="dimmed" tt="uppercase" fw={600} mt={6}>
          Manage explore profile
        </Text>

        <Tabs
          value={tab}
          onChange={(v) => v && navigate(`${basePath}/${v}`)}
          mt="lg"
          keepMounted={false}
          color="blue"
          variant="outline"
        >
          <Tabs.List grow>
            <Tabs.Tab value="itinerary">Itinerary days</Tabs.Tab>
            <Tabs.Tab value="comparisons">Comparisons</Tabs.Tab>
            <Tabs.Tab value="notes">Cover notes</Tabs.Tab>
          </Tabs.List>
        </Tabs>

        <Box mt="xl">
          <Outlet context={{ profileId: id, profileTitle }} />
        </Box>
      </Paper>
    </Box>
  );
};

export default ExploreProfileManageLayout;